var vm;

(function () {

    'use strict';
    var controllerId = 'eirGTOPrintCtrl';
    angular
        .module('app.controllers')
        .controller(controllerId, eirGTOPrintCtrl);

    eirGTOPrintCtrl.$inject = ['common', 'datacontext', '$http', '$scope', '$stateParams','$timeout','moment'];
    
    function eirGTOPrintCtrl(common, datacontext, $http, $scope, $stateParams,$timeout,moment) {

        vm = this;

        init();
        function init() {
            var divElement = angular.element(document.querySelector('#header'));
            divElement.hide();
            common.activateController([])
                .then(function (data) {

             });


            return datacontext.eir.getEirGTO($stateParams.EIRId).then(function (data) {                

               if (data) {
                   var d = new Date(data.Eir.EndDate);
                   var yardDate = moment(d).format("DD/MM/YYYY HH:mm:ss");

                    var modelEIRData = data.Eir.GateOperationEquipments[0];
                    vm.EIR = modelEIRData.EIR;
                    vm.EquipmentSizeType =  modelEIRData.EquipmentNo + ' (' + modelEIRData.SizeName +')'
                    vm.EquipmentFamilyCode = modelEIRData.EquipmentFamilyCode;
                    vm.YardDateTime = $("#currentYardName").text() +" "+yardDate;
                    vm.ConditionName = modelEIRData.ConditionName;
                    vm.ConditionNameMaqTank = modelEIRData.ConditionNameMaqTank;
                    vm.PortLoading = modelEIRData.PortLoading;
                    vm.ReferenceDocumentNo = modelEIRData.ReferenceDocumentNo;
                    vm.VesselName = modelEIRData.VesselName;
                    vm.Voyage = modelEIRData.Voyage;
                    vm.SealString = modelEIRData.sealString;
                    vm.CarrierCustomerBL = modelEIRData.Line + ' - ' + modelEIRData.CustomerName;
                    vm.TemperateUnitString = modelEIRData.TemperateUnitString;
                    vm.VentilationUnitString = modelEIRData.VentilationUnitString;
                    vm.HumidityString = modelEIRData.HumidityString;
                    vm.O2String = modelEIRData.O2String;
                    vm.CO2String = modelEIRData.co2String;
                    vm.GensetEquipmentNo = modelEIRData.GensetEquipmentNo;
                    vm.GensetDiesel = modelEIRData.GensetDiesel;
                    vm.GensetHoromoter = modelEIRData.GensetHoromoter;
                    vm.GensetSealsString =  modelEIRData.GensetsealsString;
                    vm.CustomerName =  data.Eir.CustomerName;
                    vm.DriverName =  data.Eir.DriverName;
                    vm.Plate = data.Eir.LicensePlateNo;
                    vm.QREquipmentNo = modelEIRData.EquipmentNo;
                    vm.CheckList = data.CheckList;
                    vm.DriverPhone = data.Eir.DriverPhone;
                    vm.Trucker = data.Eir.TruckerName;
                    $timeout(function () { window.print(); }, 100);

                }                

            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

    }    
})();